'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Label(props) {
  var label = props.label,
      inputId = props.inputId,
      disabled = props.disabled,
      hideLabel = props.hideLabel,
      id = props.id;

  var getLabelClassNames = function getLabelClassNames() {
    return (0, _classnames2["default"])('rainbow-table-input-checkbox_label', {
      'rainbow-table-input-checkbox_label--disabled': disabled,
      'rainbow-table-input-checkbox_label--hide': hideLabel
    });
  };

  return _react2["default"].createElement('label', {
    className: 'rainbow-table-input-checkbox_label-container',
    htmlFor: inputId,
    id: id
  }, _react2["default"].createElement('span', {
    className: 'rainbow-table-input-checkbox_faux'
  }), _react2["default"].createElement('span', {
    className: getLabelClassNames()
  }, label));
}

Label.propTypes = {
  label: _propTypes2["default"].node.isRequired,
  inputId: _propTypes2["default"].string.isRequired,
  disabled: _propTypes2["default"].bool.isRequired,
  hideLabel: _propTypes2["default"].bool,
  id: _propTypes2["default"].string
};
Label.defaultProps = {
  hideLabel: false,
  id: undefined
};